const CREDENTIAL_KEY = 'ghostscreen.device.credential';
const DEVICE_CODE_KEY = 'ghostscreen.device.code';
function randomDeviceCode() {
    const suffix = crypto.randomUUID().replace(/-/g, '').slice(0, 8).toUpperCase();
    return `GS-${suffix}`;
}
/** localStorage-backed credentials for browser / Tizen web shells. */
export class LocalStorageCredentialStore {
    async get() {
        const raw = localStorage.getItem(CREDENTIAL_KEY);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    async set(credential) {
        localStorage.setItem(CREDENTIAL_KEY, JSON.stringify(credential));
    }
    async clear() {
        localStorage.removeItem(CREDENTIAL_KEY);
    }
    async getOrCreateDeviceCode() {
        const existing = localStorage.getItem(DEVICE_CODE_KEY);
        if (existing)
            return existing;
        const code = randomDeviceCode();
        localStorage.setItem(DEVICE_CODE_KEY, code);
        return code;
    }
}
//# sourceMappingURL=local-storage-credential-store.js.map